import React from 'react'
import { TableInstance } from 'react-table'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import FilterListIcon from '@mui/icons-material/FilterList'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

const ClearButton = styled(Button)`
  background-color: white;
  margin-left: 10px;
  border: 1px solid ${props => props.theme.palette.primary.main};
  height: 2em;
  min-width: 42px;
  margin-right: 1em;
`

const TableFiltersWrapper = styled.div`
  display: flex;
  background-color: ${ThemeColorsHospitalic.PRIMARY_LIGHT};

  .MuiTypography-root {
    font-size: 10px;
  }
    align-items: center;
    justify-content: center;
    border-radius: 0.5em 0.5em 0 0;
`

const TableFiltersWrapperInner = styled.div`
  display: flex;
  align-items: center;
  background-color: ${ThemeColorsHospitalic.PRIMARY_LIGHT};
  color: ${props => props.theme.palette.text.primary};
  border-radius: 5px;
  padding-left: 5px;
`
const FilterOptionContainer = styled.div`
    &:not(:first-child) {
        padding-right: 1.5em;
    }
`

type Props = {
    instance: TableInstance
}

export default function TableFilters({ instance }: Props) {
    const { allColumns, setAllFilters } = instance

    const filtersOrder = [
        'Source',
        'Transcript consequences',
        'Allele Frequency',
        'Region',
    ]

    return (
        <TableFiltersWrapper>
            <TableFiltersWrapperInner>
                <FilterListIcon sx={{ fontSize: '11px', marginRight: '9px' }} />
                {filtersOrder.map(key => {
                    const column = allColumns.find(
                        column => column.Header === key
                    )
                    if (column) {
                        return <FilterOptionContainer key={key}><>{column.render('Filter')}</></FilterOptionContainer>
                    }
                    return undefined
                })}
            </TableFiltersWrapperInner>
            <ClearButton onClick={() => setAllFilters([])} variant='outlined'>
                <Typography variant='body1' color='primary.main'>
                    Clear
                </Typography>
            </ClearButton>
        </TableFiltersWrapper>
    )
}
